import type * as React from "react"
import { cn } from "../../lib/utils"
import {
  TooltipArrow as TooltipArrowBase,
  Tooltip as TooltipBase,
  TooltipContent as TooltipContentBase,
  TooltipProvider as TooltipProviderBase,
  TooltipTrigger as TooltipTriggerBase,
} from "../ui/tooltip"

interface TooltipProps {
  children: React.ReactNode
  content: React.ReactNode
  delayDuration?: number
  open?: boolean
  defaultOpen?: boolean
  onOpenChange?: (open: boolean) => void
  side?: "top" | "right" | "bottom" | "left"
  align?: "start" | "center" | "end"
  contentClassName?: string
  contentProps?: React.ComponentPropsWithoutRef<typeof TooltipContentBase>
}

export const Tooltip = ({
  children,
  content,
  side = "top",
  align = "center",
  delayDuration = 300,
  contentClassName,
  contentProps,
  ...props
}: TooltipProps) => {
  return (
    <TooltipProviderBase delayDuration={delayDuration}>
      <TooltipBase {...props}>
        <TooltipTriggerBase asChild>{children}</TooltipTriggerBase>
        <TooltipContentBase
          side={side}
          align={align}
          className={cn(
            "overflow-hidden max-w-[15rem]",
            "rounded-8 px-4 py-2",
            "bg-feedback-primary-background text-root-size-body-md text-feedback-inverse-text",
            contentClassName
          )}
          {...contentProps}
        >
          <TooltipArrowBase className="fill-feedback-primary-background" />
          {content}
        </TooltipContentBase>
      </TooltipBase>
    </TooltipProviderBase>
  )
}

Tooltip.displayName = "Tooltip"
